import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsCycleTimeClassicRoute: InvariantJiraRoute = {
	name: 'software-reports-cycle-time-classic',
	path: '/jira/software/c/projects/:projectKey/reports/cycle-time',
	exact: true,
};
